import { render, staticRenderFns } from "./RestaurantPhoto.vue?vue&type=template&id=bcbf1af6&scoped=true&"
import script from "./RestaurantPhoto.vue?vue&type=script&lang=js&"
export * from "./RestaurantPhoto.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantPhoto.vue?vue&type=style&index=0&id=bcbf1af6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbf1af6",
  null
  
)

export default component.exports